import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './styles.module.scss';
import Ellipse from '@/assets/svg/ellipse.svg';

interface Props {
  label?: string;
  disabled?: boolean;
  icon?: string | ReactNode;
  activated?: boolean;
  inputStyle?: string;
  onClick?: () => void;
  id?: string;
  imgStyles?: string;
  ariaLabel?: string;
}

const Button: React.FC<Props> = ({ label, disabled, icon, activated, inputStyle, onClick, id, imgStyles, ariaLabel }) => {
  const normalizeInputStyle = clsx('button2', styles.button, inputStyle);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onClick?.();
  };

  return (
    <button className={normalizeInputStyle} disabled={disabled} onClick={handleClick} id={id} aria-label={ariaLabel || label || id}>
      {icon &&
        (typeof icon === 'string' ? <img src={icon} id={label} alt={label} className={clsx(styles.button_icon, imgStyles)} /> : icon)}
      {label}
      {activated && <img src={Ellipse} alt='Activated' className={styles.button_activatedEllipse} />}
    </button>
  );
};

export default Button;
